<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <component
      id="ticketszhold-chart-header"
      v-if="!timeout"
      :is="chartType + 'Chart'"
      :chartId="chartId"
      :data="chartData"
      :options="chartOptions"
    ></component>
    <div v-if="timeout" class="text-center">
      <i class="fa fa-refresh fa-5x text-danger" aria-hidden="true"></i>
      <p>{{ name }}</p>
      <p class="text-muted">
        Sorry, we've been unable to refresh the chart data whilst the feed is
        updating, we will try again soon.
      </p>
    </div>
    <b-tooltip target="ticketszhold-chart-header" triggers="hover"
      >Tickets Not Invoiced (ZHOLD) is a stacked bar that shows tickets waiting
      to be invoiced. Hover over a bar segment to see more.</b-tooltip
    >
    <b-row v-if="1==2" class="mx-1 my-2 small charttotals">
      <b-col cols="auto" class="py-2">TOTALS:</b-col>
      <b-col
        cols="auto"
        v-for="(total, index) in totals"
        :key="index"
        class="py-2"
      >
        <div>
          <span class="bg-light p-1 text-dark">{{ total.key }}</span>         
            <b-badge variant="primary ml-2">{{ total.value }}</b-badge>
          <!-- <span class="text-primary">{{ total.value }}</span> -->
        </div>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import randomColor from "randomcolor";
import moment from "moment";

import HorizontalbarChart from "@/pages/private/charts/Horizontalbar-chart";
import shortid from "shortid";

export default {
  name: "TickNIChart",
  props: ["tile", "refresh"],
  components: {
    HorizontalbarChart,
  },
  data() {
    return {
      busy: false,
      timeout: false,
      name: "TickNI Chart",
      chartId: shortid.generate(),
      defaultOptions: {
        horizontalbar: {
          responsive: true,
          maintainAspectRatio: true,
          tooltips: {
            enabled: true,
          },
          title: {
            display: true,
            text: "TickNI Chart",
          },
          legend: {
            display: false,
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize: 11,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {},
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                  color: "#fff",
                  zeroLineColor: "#fff",
                  zeroLineWidth: 0,
                },
                ticks: {
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize: 11,
                },
                stacked: true,
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                // var total = dataset.data.reduce(function (
                //   previousValue,
                //   currentValue,
                //   currentIndex,
                //   array
                // ) {
                //   return previousValue + currentValue;
                // });
                var currentValue = dataset.data[tooltipItem.index];
                if (currentValue > 0) {
                  return dataset.label + ": " + currentValue;
                } else {
                  return null;
                }
                // var percentage = currentValue; //parseFloat((currentValue / total) * 100 + 0.5).toFixed(2);

                // let raw = dataset.raw[tooltipItem.index];
                // return raw.key + " : " + raw.value;
                // return dataset.label+' '+currentValue;
                // return percentage + "%";
              },
              //   afterLabel: function(tooltipItem, data) {
              //     let raw =
              //       data.datasets[tooltipItem.datasetIndex].raw[
              //         tooltipItem.index
              //       ];
              //     // console.log(raw);
              //     return [
              //       "Name: " + raw.key,
              //       "Value: " + raw.value,
              //     ];
              //   }
            },
          },
          onClick: function (evt, item) {
            var activePoints = this.getElementsAtEvent(evt);
            var firstPoint = activePoints[0];
          },
        },
      },
      chartData: null,
      chartOptions: null,
      chartEvents: null,
      totals: [],
    };
  },
  async mounted() {
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    ...mapGetters(["palette", "user"]),
    chartType() {
      if (!this.tile.settings) {
        return "horizontalbar";
      }
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "horizontalbar";
      }
    },
  },
  methods: {
    async loadChart() {
      if (!this.tile.settings) return;
      console.log("loadChart: TickNIChart");

      let setting = null;

      this.timeout = false;
      this.busy = true;
      let variables = {};

      console.log("variables", variables, this.tile);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query chart_ticketszhold {
              chart_ticketszhold {
                labels
                datasets {
                  label
                  data
                }
                raw {
                  key
                  value
                }
              }
            }
          `,
          variables,
        });

        if (!response.data.chart_ticketszhold) {
          this.busy = false;
          this.timeout = true;
          return;
        }
        if (response.data.chart_ticketszhold.datasets.length == 0) {
          this.busy = false;
          this.timeout = true;
          return;
        }

        this.chartData = {
          labels: response.data.chart_ticketszhold.labels,
          datasets: response.data.chart_ticketszhold.datasets,
        };
        for (var i = 0; i < this.chartData.datasets.length; i++) {
          // MAKE SURE WE HAVE ENOUGH PALLETES FOR THIS ONE
          let palette = null;
          if (i < this.palette.length) {
            palette = this.palette[i];
          } else {
            let hexColor = randomColor();
            palette = {
              backgroundColor: randomColor({
                luminosity: "dark",
                format: "rgba",
                alpha: 0.1, // e.g. 'rgba(9, 1, 107, 0.5)',
              }),
              borderColor: hexColor,
              pointHoverBackgroundColor: hexColor,
              borderWidth: 2,
            };
          }
          this.chartData.datasets[i].backgroundColor = palette.borderColor;
        }

        this.totals = [];
        for (var i = 0; i < response.data.chart_ticketszhold.raw.length; i++) {
          if (
            response.data.chart_ticketszhold.raw[i].key.slice(0, 6) == "total_"
          ) {
            this.totals.push({
              key: response.data.chart_ticketszhold.raw[i].key.replace(
                "total_",
                ""
              ),
              value: response.data.chart_ticketszhold.raw[i].value,
            });
          }
        }

        // backgroundColor: this.bars.options.colors[j]

        // FIND THE DATE AND PUSH THE COLOUR
        // for (var i = 0; i < chartData.datasets.length; i++) {
        //   let colour = this.defaultOptions.palette[i];
        //   chartData.datasets[i].backgroundColor = colour.borderColor;
        // }

        // GET THE DEFAULT OPTIONS FOR THE CHART TYPE
        this.chartOptions = this.defaultOptions[this.chartType];

        let setting = null;

        setting = this.tile.settings.find((o) => o.key == "title");
        if (setting.value) {
          this.chartOptions.title = {
            display: true,
          };
          setting = this.tile.settings.find((o) => o.key == "titletext");
          if (setting) {
            // REPLACE LATER WITH FORMATTED
            let titletext = "Tickets Not Invoiced (ZHOLD) By Event";
            // let titletext = this.name + " ( " + variables.source + " )";
            if (variables.daterange) {
              titletext +=
                " " +
                this.$moment(
                  variables.daterange.split("-")[0],
                  "DD/MM/YYYY"
                ).format("MMM YYYY") +
                " slice";
            }
            this.chartOptions.title.text = titletext;
          }
        } else {
          this.chartOptions.title = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "legend");
        if (setting.value) {
          this.chartOptions.legend = {
            display: true,
          };
          setting = this.tile.settings.find((o) => o.key == "legendposition");
          if (setting) {
            this.chartOptions.legend.position = setting.value;
          }
          this.chartOptions.legend.labels = { boxWidth: 12 };
        } else {
          this.chartOptions.legend = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "datalabels");
        if (setting.value) {
          this.chartOptions.datalabels = {
            display: false,
          };
        } else {
          this.chartOptions.datalabels = {
            display: false,
          };

        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      await this.$emit("refreshed");
    },
  },
};
</script>

<style>
</style>